var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9879 0H0.893326C0.403437 0 0 0.432254 0 0.95096V11.9879C0 12.5066 0.403437 12.91 0.893326 12.91H11.9879C12.4777 12.91 12.91 12.5066 12.91 11.9879V0.95096C12.91 0.432254 12.4777 0 11.9879 0ZM3.89029 11.0657H1.98837V4.9277H3.89029V11.0657ZM2.93933 4.06319C2.30536 4.06319 1.81547 3.5733 1.81547 2.96815C1.81547 2.36299 2.30536 1.84429 2.93933 1.84429C3.54449 1.84429 4.03437 2.36299 4.03437 2.96815C4.03437 3.5733 3.54449 4.06319 2.93933 4.06319ZM11.0657 11.0657H9.13498V8.06875C9.13498 7.37714 9.13498 6.455 8.1552 6.455C7.14661 6.455 7.00252 7.23306 7.00252 8.03993V11.0657H5.1006V4.9277H6.91607V5.76339H6.94489C7.20424 5.2735 7.83821 4.7548 8.76036 4.7548C10.6911 4.7548 11.0657 6.05156 11.0657 7.69413V11.0657Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin.3c9cc3d0.svg";
export { ForwardRef as ReactComponent };